import {register} from 'dna-react-ioc'
import {TResetPasswordFailureStore} from '@/pages/ResetPasswordFailure'
import {ResetPasswordFailureStoreSymbol} from '@/pages/ResetPasswordFailure/ResetPasswordFailure'
import {ResetPasswordFailureStore} from '@/stores/reset-password-failure/ResetPasswordFailureStore'
import {TResetPasswordStore} from '@/pages/ResetPassword'
import {ResetPasswordStoreSymbol} from '@/pages/ResetPassword/ResetPassword'
import {ConfirmEmailStore, PasswordRecoveryStore, ChangeOldPasswordStore} from '@/stores'
import {TConfirmEmailStore} from '@/pages/ConfirmEmail'
import {ConfirmEmailStoreSymbol} from '@/pages/ConfirmEmail/ConfirmEmail'
import {IChangeOldPasswordStore} from '@/pages/ChangeOldPassword'
import {ChangeOldPasswordStoreSymbol} from '@/pages/ChangeOldPassword/ChangeOldPassword'

export const resetPasswordState = () => {
    register<TResetPasswordStore>(ResetPasswordStoreSymbol)
        .to(PasswordRecoveryStore)
        .inSingletonScope()
    register<TConfirmEmailStore>(ConfirmEmailStoreSymbol).to(ConfirmEmailStore).inSingletonScope()
    register<IChangeOldPasswordStore>(ChangeOldPasswordStoreSymbol)
        .to(ChangeOldPasswordStore)
        .inSingletonScope()
    register<TResetPasswordFailureStore>(ResetPasswordFailureStoreSymbol)
        .to(ResetPasswordFailureStore)
        .inSingletonScope()
}
